Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.SimplecastEpisode = void 0;
var _react = _interopRequireDefault(require("react"));
var _generalObserver = require("../general-observer");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
var SimplecastEpisode = function SimplecastEpisode(_ref) {
  var episodeId = _ref.episodeId,
    _ref$theme = _ref.theme,
    theme = _ref$theme === void 0 ? "light" : _ref$theme;
  return /*#__PURE__*/_react["default"].createElement(_generalObserver.GeneralObserver, null, /*#__PURE__*/_react["default"].createElement("div", {
    className: "simplecast-episode-mdx-embed",
    style: {
      position: 'relative',
      height: '200px',
      width: '100%'
    }
  }, /*#__PURE__*/_react["default"].createElement("iframe", {
    "data-testid": "simplecast-episode",
    title: "simplecast-".concat(episodeId),
    src: "https://player.simplecast.com/".concat(episodeId).concat(theme === "dark" ? "?dark=true" : ""),
    frameBorder: "no",
    scrolling: "no",
    seamless: true,
    style: {
      position: 'absolute',
      top: 0,
      left: 0,
      width: '100%',
      height: '100%'
    }
  })));
};
exports.SimplecastEpisode = SimplecastEpisode;